var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 29.3334H20.4998C27.1665 29.3334 29.8332 26.6667 29.8332 20.0001V12.0001C29.8332 5.33341 27.1665 2.66675 20.4998 2.66675H12.4998C5.83317 2.66675 3.1665 5.33341 3.1665 12.0001V20.0001C3.1665 26.6667 5.83317 29.3334 12.4998 29.3334Z",
    stroke: "#0073BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 13.3333C13.9729 13.3333 15.1668 12.1394 15.1668 10.6667C15.1668 9.19391 13.9729 8 12.5002 8C11.0274 8 9.8335 9.19391 9.8335 10.6667C9.8335 12.1394 11.0274 13.3333 12.5002 13.3333Z",
    stroke: "#0073BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06006 25.2666L10.6334 20.8532C11.6867 20.1466 13.2067 20.2266 14.1534 21.0399L14.5934 21.4266C15.6334 22.3199 17.3134 22.3199 18.3534 21.4266L23.9001 16.6666C24.9401 15.7732 26.6201 15.7732 27.6601 16.6666L29.8334 18.5332",
    stroke: "#0073BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImages);
export default __webpack_public_path__ + "static/media/upload-images.75883a9e9d2e3ed39909f7c2f2a24499.svg";
export { ForwardRef as ReactComponent };